import { fromJS, List } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  settings: {},
  navExpand: false,
  navHidden: false,
  loading: false,
  updateLogoLoading: false,
  error: "",
  toastList: {},
  notificationToast: {},
  modal: true,
  dashboardSummary: {},
  notificationsList: [],
  reminders: [],
  createdReminders: [],
  reminder: {},
  pjmDashboardSummary: {},
  prmDashboardSummary: {},
  pomDashboardSummary: {},
  pomDashboardDetail: {},
});

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.DASHBOARD_SUMMARY.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.DASHBOARD_SUMMARY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("dashboardSummary", action.data);
    }

    case ACTIONS.DASHBOARD_SUMMARY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.ACCOUNT_SETTINGS.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.ACCOUNT_SETTINGS.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("settings", action.data);
    }

    case ACTIONS.ACCOUNT_SETTINGS.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.UPDATE_ACCOUNT_SETTINGS.PENDING: {
      return state.set("loading", true);
    }

    case ACTIONS.UPDATE_ACCOUNT_SETTINGS.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("settings", action.data);
    }

    case ACTIONS.UPDATE_ACCOUNT_SETTINGS.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.UPDATE_ACCOUNT_LOGO.PENDING: {
      return state.set("updateLogoLoading", true);
    }

    case ACTIONS.UPDATE_ACCOUNT_LOGO.SUCCESS: {
      return state
        .set("updateLogoLoading", false)
        .set("error", "")
        .set("settings", action.data);
    }

    case ACTIONS.UPDATE_ACCOUNT_LOGO.ERROR: {
      return state.set("updateLogoLoading", false).set("error", action.error);
    }

    case ACTIONS.NOTIFICATION_TOAST: {
      return state.set("notificationToast", action.data);
    }

    case ACTIONS.ADD_TOAST_IN_LIST: {
      return state.set("toastList", action.data);
    }

    case ACTIONS.REMOVE_TOAST_IN_LIST: {
      return state.set("toastList", null).set("notificationToast", null);
    }

    case ACTIONS.UPDATE_NAV_EXPAND: {
      return state.set("navExpand", !state.get("navExpand"));
    }

    case ACTIONS.UPDATE_NAV_HIDDEN: {
      return state.set("navHidden", !state.get("navHidden"));
    }

    case ACTIONS.CLOSE_MODAL: {
      return state.set("modal", !state.get("modal"));
    }

    case ACTIONS.NOTIFICATIONS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("notificationsList", action.data);
      // return state.update('notificationsList', notificationsList =>
      //   notificationsList.push(action.data)
      // );
    }

    case ACTIONS.GET_NOTIFICATIONS.PENDING: {
      return state.set("loading", true);
    }

    case ACTIONS.GET_NOTIFICATIONS.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("notificationsList", action.data);
    }

    case ACTIONS.GET_NOTIFICATIONS.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.DELETE_NOTIFICATION.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.DELETE_NOTIFICATION.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("notificationsList", action.data);

      // const prev = state.get('notificationsList');
      // const newArr = prev.filter((n) => n.id !== action.data)
      // return state.set('loading', false)
      //   .set('error', '')
      //   .set('notificationsList', newArr);
    }

    case ACTIONS.DELETE_NOTIFICATION.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.MARK_NOTIFICATION_READ.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.MARK_NOTIFICATION_READ.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("notificationsList", action.data);
    }

    case ACTIONS.MARK_NOTIFICATION_READ.ERROR: {
      return state.set("loading", false)
        .set("error", action.error);
    }

    case ACTIONS.MARK_REMINDER_READ.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.MARK_REMINDER_READ.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders);
    }

    case ACTIONS.MARK_REMINDER_READ.ERROR: {
      return state.set("loading", false)
        .set("error", action.error);
    }

    case ACTIONS.REMINDERS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders);
    }

    case ACTIONS.REMINDER_SNOOZE.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.REMINDER_SNOOZE.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders);
    }

    case ACTIONS.REMINDER_SNOOZE.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.CLEAR_REMINDER: {
      return state.set("reminder", null);
    }

    case ACTIONS.CREATE_REMINDER.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.CREATE_REMINDER.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders)
        .set("reminder", null);
    }

    case ACTIONS.CREATE_REMINDER.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.UPDATE_REMINDER.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.UPDATE_REMINDER.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders)
        .set("reminder", null);
    }

    case ACTIONS.UPDATE_REMINDER.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.GET_REMINDERS.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.GET_REMINDERS.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders);
    }

    case ACTIONS.GET_REMINDERS.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.FETCH_REMINDER.PENDING: {
      return state.set("loading", true);
    }

    case ACTIONS.FETCH_REMINDER.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminder", action.data);
    }

    case ACTIONS.FETCH_REMINDER.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.DELETE_REMINDER.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.EXP_RES: {
      return state.set("expRes", action.data);
    }
    case ACTIONS.EXP_CLIENTS: {
      return state.set("expClients", action.data);
    }
    case ACTIONS.EXP_MEETINGS: {
      return state.set("expMeetings", action.data);
    }
    case ACTIONS.EXP_PROJECTS: {
      return state.set("expProjects", action.data);
    }

    case ACTIONS.DELETE_REMINDER.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("reminders", action.data?.reminders)
        .set("createdReminders", action.data?.createdReminders);
    }

    case ACTIONS.DELETE_REMINDER.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.PJM_DASHBOARD_SUMMARY.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.PJM_DASHBOARD_SUMMARY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("pjmDashboardSummary", action.data);
    }

    case ACTIONS.PJM_DASHBOARD_SUMMARY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.PJM_DASHBOARD_DETAIL.PENDING: {
      return state
        .set("detailLoading", true)
        .set("detailError", "");
    }

    case ACTIONS.PJM_DASHBOARD_DETAIL.SUCCESS: {
      return state
        .set("detailLoading", false)
        .set("detailError", "")
        .set("pjmDashboardDetail", action.data);
    }

    case ACTIONS.PJM_DASHBOARD_DETAIL.ERROR: {
      return state
        .set("detailLoading", false)
        .set("detailError", action.error);
    }

    case ACTIONS.PRM_DASHBOARD_SUMMARY.PENDING: {
      return state.set("loading", false);
    }

    case ACTIONS.PRM_DASHBOARD_SUMMARY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("prmDashboardSummary", action.data);
    }

    case ACTIONS.PRM_DASHBOARD_SUMMARY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.PRM_DASHBOARD_DETAIL.PENDING: {
      return state
        .set("detailLoading", true)
        .set("detailError", "");
    }

    case ACTIONS.PRM_DASHBOARD_DETAIL.SUCCESS: {
      return state
        .set("detailLoading", false)
        .set("detailError", "")
        .set("prmDashboardDetail", action.data);
    }

    case ACTIONS.PRM_DASHBOARD_DETAIL.ERROR: {
      return state
        .set("detailLoading", false)
        .set("detailError", action.error);
    }

    case ACTIONS.CLEAR_PRM_DASHBOARD_DATA: {
      return state.set('prmDashboardSummary', fromJS({}))
        .set('prmDashboardDetail', fromJS({}));
    }

    case ACTIONS.CLEAR_PJM_DASHBOARD_DATA: {
      return state.set('pjmDashboardSummary', fromJS({}))
        .set('pjmDashboardDetail', fromJS({}));
    }

    case ACTIONS.CLEAR_POM_DASHBOARD_DATA: {
      return state
        .set('pomDashboardDetail', fromJS({}))
        .set('detailLoading', false);
    }

    case ACTIONS.POM_DASHBOARD_SUMMARY.PENDING: {
      return state.set("loading", true);
    }

    case ACTIONS.POM_DASHBOARD_SUMMARY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("pomDashboardSummary", action.data);
    }

    case ACTIONS.POM_DASHBOARD_SUMMARY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.POM_DASHBOARD_DETAIL.PENDING: {
      return state
        .set("detailLoading", true)
        .set("detailError", "");
    }

    case ACTIONS.POM_DASHBOARD_DETAIL.SUCCESS: {
      return state
        .set("detailLoading", false)
        .set("detailError", "")
        .set("pomDashboardDetail", action.data);
    }

    case ACTIONS.POM_DASHBOARD_DETAIL.ERROR: {
      return state
        .set("detailLoading", false)
        .set("detailError", action.error);
    }


    default: {
      return state;
    }
  }
}
